export enum LANGUAGES {
    EN = 'en',
    DE = 'de',
}
